export default class Callback {
    _tracker;
    _trackIndex;

    /**
     * @param {function} callbackFn - The callback function
     */
    constructor(callbackFn) {
        this._tracker = callbackFn;
        this._trackIndex = -1;
    }

    get trackIndex() {
        return this._trackIndex;
    }

    /**
     * track an url or event
     * @param {string} type - The type of track
     * @param {*} payload - The tracking payload
     * @param {number} trackIndex - The index of the track event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    track(type, payload, trackIndex) {
        this._trackIndex = trackIndex;
        if (type === 'event') {
            return this._trackEvent();
        } else if(type === 'page') {
            return this._trackPage(payload.url, payload.content, payload.title);
        }
    }

    /**
     * track an url
     * @param {string} url - The url of the page
     * @param {*} content - The current player content
     * @param {string} title - The page title
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackPage(url, content, title) {
        this._tracker(url, content, title);
        return Promise.resolve(true);
    }

    /**
     * track an event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackEvent() {
        //TODO do we have event tracking for callbacks?
        return Promise.resolve(true);
    }

    /**
     * destroy the tracker instance and clean up if necessary
     */
    destroy() {

    }

    /**
     * repeat calls to this function will not discover the same tracker again
     * @returns - A promise resolving an array of wrapper instances for discovered tracker
     */
    static discover() {
        //TODO maybe spec out a way to add callbacks via window object
        return Promise.resolve([]);
    }

    /**
     * initialize general purpose things like the tracker's library js
     */
    static init() {
        return Promise.resolve();
    }

    /**
     * @param {*} options - The tracker options 
     * @returns - A promise resolving the wrapper instance
     */
    static create({trackPage}) {
        return new Promise((resolve, reject) => {
            resolve(new Callback(trackPage));
        })
    }
}


// WEBPACK FOOTER //
// ./lib/analytics/tracker-callback.js